import { DefaultTheme } from "styled-components";

/**
 *  PNNL Color Guidelines: https://reputation.pnl.gov/default.aspx?topic=Colors
 */
declare module "styled-components" {
  export interface DefaultTheme {
    fonts: {
      /** For regular text through */
      main: string;
      /** For Headings and attention grabbers */
      heading: string;
    };
    colors: {
      main: string;
      secondary: string;
      hover: string;
      disable: string;
      error: string;
    };
    backgrounds: {
      foreground: string;
      background: string;
      lines: string;
      borders: string;
      /** For active Theme */
      primary: string;
      secondary: string;
    };
    card: {
      background: string;
      foreground: string;
    };
    button: {
      color: string;
      background: string;
      hover: {
        color: string;
        border: string;
      };
      focus: string;
    };
    pnnl: {
      copper: string;
      silver: string;
      bronze: string;
      gold: string;
      platinum: string;
      onyx: string;
      emerald: string;
    };
  }
}

// export const lightTheme: DefaultTheme = {
//   fonts: {
//     main: "Roboto",
//     heading: "Archivo",
//   },
//   colors: {
//     main: "#000000",
//     secondary: "#717171",
//     hover: "rgba(183, 183, 183, .4)",
//     disable: "#bfbdbd",
//   },
//   backgrounds: {
//     foreground: "#FFFFFF",
//     background: "rgb(232,232,232)",
//     primary: "#007836",
//   },
//   button: {
//     color: "#191C1F",
//     background: "#F4AA00",
//     hover: {
//       color: "#191C1F",
//       border: "#F4AA00",
//     },
//     focus: "#191C1F",
//   },
//   pnnl: {
//     copper: "#D77600",
//     silver: "#616265",
//     bronze: "#A63F1E",
//     gold: "#F4AA00",
//     platinum: "#B3B3B3",
//     onyx: "#191C1F",
//     emerald: "#007836",
//   },
// };

// export const darkTheme: DefaultTheme = {
//   fonts: {
//     main: "Roboto",
//     heading: "Archivo",
//   },
//   colors: {
//     main: "rgb(183, 183, 183)",
//     secondary: "#717171",
//     hover: "rgba(183, 183, 183, .2)",
//     disable: "#5c5c5c",
//   },
//   backgrounds: {
//     foreground: "rgb(60,66,84)",
//     background: "rgb(38,47,62)",
//     primary: "#F4AA00",
//   },
//   button: {
//     color: "#191C1F",
//     background: "#F4AA00",
//     hover: {
//       color: "rgb(183, 183, 183)",
//       border: "#F4AA00",
//     },
//     focus: "#191C1F",
//   },
//   pnnl: {
//     copper: "#D77600",
//     silver: "#616265",
//     bronze: "#A63F1E",
//     gold: "#F4AA00",
//     platinum: "#B3B3B3",
//     onyx: "#191C1F",
//     emerald: "#007836",
//   },
// };

export const mainTheme: DefaultTheme = {
  fonts: {
    main: "Roboto",
    heading: "Archivo",
  },
  colors: {
    main: "#FFFFFF",
    secondary: "#717171",
    hover: "rgba(183, 183, 183, .4)",
    disable: "#bfbdbd",
    error: "#ff4d4f",
  },
  backgrounds: {
    foreground: "rgb(68, 102, 124)",
    background: "#FFFFFF",
    lines: "#ACACAC",
    borders: "#EEEEEE",
    primary: "#131921", //"#004727",
    secondary: "#232f3e", //"#470020",
  },
  card: {
    background: "#f9f9f9",
    foreground: "#D9D9D9",
  },
  button: {
    color: "#191C1F",
    background: "#F4AA00",
    hover: {
      color: "#191C1F",
      border: "#F4AA00",
    },
    focus: "#191C1F",
  },
  pnnl: {
    copper: "#D77600",
    silver: "#616265",
    bronze: "#A63F1E",
    gold: "#F4AA00",
    platinum: "#B3B3B3",
    onyx: "#191C1F",
    emerald: "#007836",
  },
};
